import { useNavigate } from "react-router-dom";

export default function SiteCta({
  title,
  desc,
  buttonText,
  to,
  onClick,
  variant = "band",
  badge,
  accent,
  secondaryButtonText,
  secondaryTo,
  secondaryOnClick,
}) {
  const navigate = useNavigate();

  const handleClick = (path, customHandler) => {
    if (customHandler) {
      customHandler();
      return;
    }
    if (path) navigate(path);
  };

  if (variant === "card") {
    return (
      <section className="home-section home-section--cta animate-on-scroll">
        <div className="container">
          <div className="home-cta-card">
            {badge ? <span className="home-cta-badge">{badge}</span> : null}
            <h2>
              {title}
              {accent ? (
                <>
                  {" "}
                  <span className="home-cta-accent">{accent}</span>
                </>
              ) : null}
            </h2>
            {desc ? <p>{desc}</p> : null}
            <div className="home-cta-actions">
              {buttonText ? (
                <button
                  type="button"
                  className="home-cta-btn-primary"
                  onClick={() => handleClick(to, onClick)}
                >
                  {buttonText} <i className="bi bi-arrow-right ms-1" aria-hidden="true"></i>
                </button>
              ) : null}
              {secondaryButtonText ? (
                <button
                  type="button"
                  className="home-cta-btn-secondary"
                  onClick={() => handleClick(secondaryTo, secondaryOnClick)}
                >
                  {secondaryButtonText}
                </button>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="site-cta-section animate-on-scroll">
      <div className="container">
        <div className="site-cta-inner">
          <h2 className="site-cta-title">{title}</h2>
          {desc ? <p className="site-cta-desc">{desc}</p> : null}
          {buttonText ? (
            <button type="button" className="site-cta-btn" onClick={() => handleClick(to, onClick)}>
              {buttonText}
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
}
